// extracted by mini-css-extract-plugin
export default {"cta":"cta__pStMbnO8KZn0"};